<script setup lang="ts" generic="T">
  import { computed } from 'vue';
  import type { EntityType } from '@/shared/lib';
  import PaginatedView from './PaginatedView.vue';
  import InfiniteScrollView from './InfiniteScrollView.vue';

  const props = defineProps<{
    items?: T[];
    allItems?: T[];
    metadata?: { total?: number; totalItems?: number; page?: number } | null;
    selectedQuantity?: number;
    loadingMore?: boolean;
    hasMoreItems?: boolean;
    entityName?: EntityType;
    hideSummary?: boolean;
  }>();

  defineEmits<{ 'page-changed': [page: number] }>();

  const isInfiniteScrollMode = computed(() => Number(props.selectedQuantity) === 100);
</script>

<template>
  <div>
    <PaginatedView
      v-if="!isInfiniteScrollMode"
      :items="items ?? []"
      :metadata="metadata ?? null"
      :selected-quantity="selectedQuantity ?? 10"
      :entity-name="entityName"
      :hide-summary="hideSummary"
      @page-changed="$emit('page-changed', $event)"
    >
      <template #table>
        <slot
          name="table"
          :items="items ?? []"
        />
      </template>
    </PaginatedView>

    <InfiniteScrollView
      v-else
      :all-items="allItems ?? []"
      :loading-more="loadingMore ?? false"
      :has-more-items="hasMoreItems ?? false"
      :metadata="metadata ?? null"
      :entity-name="entityName"
      :hide-summary="hideSummary"
    >
      <template #table>
        <slot
          name="table"
          :items="allItems ?? []"
        />
      </template>
    </InfiniteScrollView>
  </div>
</template>
